import * as React from 'react';
import classnames from 'classnames';
import { SuccessIcon, WarnIcon, ErrorIcon } from '../common-view';
import Layout from '../op-layout';
import event from '../event';
import PlaySound from '../op-play-sound/index';
import './index.scss';
const { Content, Left, Right } = Layout;
export const styleConfig = {
    success: {
        icon: React.createElement(SuccessIcon, { color: '#fff' }),
        style: {
            'background-color': '#00bf29',
            color: '#ffffff',
        },
    },
    warning: {
        icon: React.createElement(WarnIcon, { color: '#000' }),
        style: {
            'background-color': '#ffd119',
            color: '#000000',
        },
    },
    error: {
        icon: React.createElement(ErrorIcon, { color: '#fff' }),
        style: {
            'background-color': '#FE3824',
            color: '#ffffff',
        },
    },
};
export default function Message(props) {
    const { visible, type = 'success', title, subTitle, right, left, content, onChange, customConfig, style, className, } = props;
    const mergedConfig = {
        ...styleConfig,
        ...(customConfig || {}),
    };
    const bindEsc = React.useCallback(() => {
        onChange(false);
    }, []);
    React.useEffect(() => {
        if (visible) {
            event.bind('esc', bindEsc);
        }
        else {
            event.unbind('esc', bindEsc);
        }
        return () => {
            event.unbind('esc', bindEsc);
        };
    }, [visible]);
    const config = (mergedConfig[type] || mergedConfig.success);
    const newStyle = { ...style, ...config.style };
    return visible ? (React.createElement(React.Fragment, null,
        React.createElement(PlaySound, { type: type, autoPlay: true, volume: 1 }),
        React.createElement(Layout, { style: newStyle, className: classnames('op-message-container', className) },
            React.createElement(Left, { middle: true }, left || React.createElement("div", { className: 'op-message-icon' }, config.icon)),
            content || (React.createElement(Content, { middle: true, className: 'op-message-msg' },
                React.createElement("div", { className: 'op-message-msg__title' }, title),
                React.createElement("div", { className: 'op-message-msg__subtitle' }, subTitle))),
            React.createElement(Right, { "data-hottag": 'cn-op.message-close', onClick: () => {
                    onChange(false);
                } }, right || (React.createElement("div", { className: 'op-message-container__right' }, "\u5173\u95ED\u2002[Esc]")))))) : null;
}
